import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
    ru: {
        menu: {
            green: "Зеленые насаждения",
            water: "Водные объекты",
            fountains: "Фонтаны",
            air: "Воздух",
            waste: "Отходы"
        },
        legend: {
            healthy: "Здоровые",
            emergency: "Аварийные",
            dry: "Сухостой",
            weakened: "Ослабленные",
            suppressed: "Угнетенные",
            dying: "Усыхающие",
            compensatory: "Комп. посадка",
            redbook: "Краснокнижные",
            coniferous: "Хвойные"
        },
        ui: {
            displayControl: "Управление отображением",
            close: "Закрыть",
            filter: "Фильтр"
        },
        air: {
            level: {
                low: "Низкий уровень",
                medium: "Повышенный уровень",
                high: "Высокий уровень",
                veryHigh: "Очень высокий уровень"
            },
            sources: {
                clarity: "Clarity",
                ecoPosts: "Эко-посты",
                kazgidromet: "Казгидромет"
            },
            common: {
                close: "Закрыть"
            }
        },
        water: {
            title: "Водные объекты",
            types: {
                lake: "Озера",
                pond: "Пруды",
                river: "Реки",
                reservoir: "Водохранилища"
            },
            district: "Район",
            close: "Закрыть"
        },
        districts: {
            alatausky: "Алатауский",
            almaly: "Алмалинский",
            auezov: "Ауэзовский",
            bostandyk: "Бостандыкский",
            zhetysu: "Жетысуский",
            medeu: "Медеуский",
            nauryzbai: "Наурызбайский",
            turksib: "Турксибский"
        },
        municipalwaste: {
            title: "Паспорт контейнерной площадки",
            id: "Идентификационный номер",
            address: "Адрес объекта",
            latitude: "Широта",
            longitude: "Долгота",
            radius: "Радиус",
            platformType: "Тип контейнерной площадки",
            area: "Площадь (м²)",
            volume: "Объем (м³)",
            containersCount: "Количество контейнеров",
            kgoZone: "Зона для КГО",
            platformBase: "Основание площадки",
            belonging: "Принадлежность",
            guardrail: "Ограждение",
            expansion: "Расширение",
            tkoFraction: "Для фракций ТКО",
            containerMaterial: "Материал контейнера",
            canopy: "Навес",
            containers: "Контейнеры",
            exportSchedule: "График вывоза",
            reportError: "Сообщить об ошибке"
        },
        airStation: {
            title: "Паспорт станции Clarity (WAQI)",
            coordinates: "Координаты",
            stationId: "ID станции",
            name: "Название",
            pm25: "Текущий PM2.5 (AQI)",
            measurementTime: "Время измерения"
        },
        fountain: {
            title: "Паспорт фонтана",
            objectId: "ID объекта",
            name: "Имя объекта",
            address: "Адрес объекта",
            constructionYear: "Год постройки",
            fountainType: "Тип фонтана",
            bowlType: "Тип чаши",
            bowlCount: "Общее количество чаш",
            area: "Площадь (м²)",
            volume: "Объем (м³)",
            underwaterLamps: "Подводные светильники",
            injectorType: "Тип форсунки",
            injectorCount: "Количество форсунок",
            condition: "Состояние",
            submersiblePumps: "Погружные насосы",
            centrifugalPumps: "Центробежные насосы",
            spotlights: "Прожекторы",
            videoCameras: "Видеокамеры",
            rgbBacklight: "RGB подсветка",
            electricity: "Электричество",
            waterSupply: "Водоснабжение",
            cadastreNumber: "Номер кадастра",
            cleaningSchedule: "График уборки",
            note: "Примечание",
            district: "Административный район",
            reportError: "Сообщить об ошибке"
        },
        lake: {
            title: "Паспорт озера",
            latitude: "Широта",
            longitude: "Долгота",
            name: "Название озера",
            district: "Адм. район",
            reportError: "Сообщить об ошибке"
        },
        pond: {
            title: "Паспорт пруда",
            latitude: "Широта",
            longitude: "Долгота",
            name: "Название водоема",
            purpose: "Назначение",
            exploitationYear: "Введен в эксплуатацию",
            district: "Адм. район",
            reportError: "Сообщить об ошибке"
        },
        river: {
            title: "Паспорт реки",
            name: "Название реки",
            districts: "Адм. районы",
            reportError: "Сообщить об ошибке"
        },
        reservoir: {
            title: "Паспорт водохранилища",
            latitude: "Широта",
            longitude: "Долгота",
            name: "Название водоема",
            exploitationYear: "Введен в эксплуатацию",
            district: "Адм. район",
            reportError: "Сообщить об ошибке"
        },
        appeal: {
            back: "Назад",
            title: "Создать заявку",
            lastName: "Фамилия",
            firstName: "Имя",
            patronymic: "Отчество",
            email: "Email",
            phone: "Номер телефона",
            phonePlaceholder: "8XXXXXXXXXX",
            bodyPlaceholder: "Текст заявки",
            addPhoto: "Добавить фото",
            send: "Отправить"
        },
        filters: {
            title: "Управление фильтрами",
            districts: "Районы",
            objects: "Объекты",
            compensatory: "Компенсационная посадка",
            redbook: "Краснокнижные",
            close: "Закрыть"
        },
        tree: {
            title: "Паспорт объекта",
            coordinates: "Координаты",
            id: "Идентификационный номер",
            breed: "Порода дерева",
            plantingType: "Вид насаждений",
            category: "Категория насаждений",
            age: "Возраст",
            height: "Высота",
            diameter: "Диаметр",
            condition: "Состояние",
            pests: "Вредители",
            disease: "Болезнь",
            event: "Хозяйственное мероприятие",
            status: "Статус",
            permitNumber: "Номер разрешения",
            plantingDate: "Дата посадки",
            addedDate: "Дата добавления в реестр",
            district: "Район",
            reportError: "Сообщить об ошибке",
            messages: "Сообщения",
            reply: "Ответ"
        },
        bush: {
            title: "Паспорт объекта",
            coordinates: "Координаты",
            id: "Идентификационный номер",
            breed: "Порода кустарников",
            plantingType: "Вид насаждений",
            plantingTypeValue: "Кустарник",
            category: "Категория насаждений",
            age: "Возраст",
            height: "Высота",
            diameter: "Диаметр",
            condition: "Состояние",
            pests: "Вредители",
            disease: "Болезнь",
            event: "Хозяйственное мероприятие",
            status: "Статус",
            permitNumber: "Номер разрешения",
            plantingDate: "Дата посадки",
            addedDate: "Дата добавления в реестр",
            district: "Район",
            reportError: "Сообщить об ошибке",
            messages: "Сообщения",
            reply: "Ответ"
        }
    },
    kz: {
        menu: {
            green: "Жасыл желектер",
            water: "Су объектілері",
            fountains: "Субұрқақтар (фонтандар)",
            air: "Ауа",
            waste: "Қалдықтар"
        },
        legend: {
            healthy: "Сау",
            emergency: "Апаттық",
            dry: "Қураған ағаш",
            weakened: "Әлсіреген (дімкәс)",
            suppressed: "Жайсыз күйдегі",
            dying: "Солып бара жатқан",
            compensatory: "Компенсациялық отырғызу",
            redbook: "Қызыл кітапқа енгізілген",
            coniferous: "Қылқан жапырақты"
        },
        ui: {
            displayControl: "Бейнелерді басқару",
            close: "Жабу",
            filter: "Сүзгі"
        },
        air: {
            level: {
                low: "Төмен деңгей",
                medium: "Көтеріңкі деңгей",
                high: "Жоғары деңгей",
                veryHigh: "Өте жоғары деңгей"
            },
            sources: {
                clarity: "Clarity",
                ecoPosts: "Эко-бекеттер",
                kazgidromet: "Қазгидромет"
            },
            common: {
                close: "Жабу"
            }
        },
        water: {
            title: "Су объектілері",
            types: {
                lake: "Көлдер",
                pond: "Тоғандар",
                river: "Өзендер",
                reservoir: "Су қоймалары"
            },
            district: "Аудан",
            close: "Жабу"
        },
        districts: {
            alatausky: "Алатау",
            almaly: "Алмалы",
            auezov: "Әуезов",
            bostandyk: "Бостандық",
            zhetysu: "Жетісу",
            medeu: "Медеу",
            nauryzbai: "Наурызбай",
            turksib: "Түрксіб"
        },
        municipalwaste: {
            title: "Контейнер алаңының паспорты",
            id: "Идентификациялық нөмір",
            address: "Нысанның мекенжайы",
            latitude: "Ендік",
            longitude: "Бойлық",
            radius: "Радиус",
            platformType: "Контейнер алаңының түрі",
            area: "Ауданы (м²)",
            volume: "Көлемі (м³)",
            containersCount: "Контейнер саны",
            kgoZone: "КГО аймағы",
            platformBase: "Алаң негізі",
            belonging: "Тиесілігі",
            guardrail: "Қоршау",
            expansion: "Кеңейту",
            tkoFraction: "ТҚҚ фракциялары үшін",
            containerMaterial: "Контейнер материалы",
            canopy: "Шатыр",
            containers: "Контейнерлер",
            exportSchedule: "Шығару кестесі",
            reportError: "Қате туралы хабарлау"
        },
        airStation: {
            title: "Clarity (WAQI) ауа станциясының паспорты",
            coordinates: "Координаттар",
            stationId: "Станция ID",
            name: "Атауы",
            pm25: "Ағымдағы PM2.5 (AQI)",
            measurementTime: "Өлшеу уақыты"
        },
        fountain: {
            title: "Субұрқақтың паспорты",
            objectId: "Нысанның ID",
            name: "Нысан атауы",
            address: "Нысан мекенжайы",
            constructionYear: "Салынған жылы",
            fountainType: "Субұрқақ түрі",
            bowlType: "Тостаған түрі",
            bowlCount: "Тостағандардың жалпы саны",
            area: "Ауданы (м²)",
            volume: "Көлемі (м³)",
            underwaterLamps: "Суасты шамдары",
            injectorType: "Форсунка түрі",
            injectorCount: "Форсункалар саны",
            condition: "Жағдайы",
            submersiblePumps: "Суасты сорғылар",
            centrifugalPumps: "Орталықтан тепкіш сорғылар",
            spotlights: "Прожекторлар",
            videoCameras: "Бейнекамералар",
            rgbBacklight: "RGB жарықтандыру",
            electricity: "Электрмен жабдықтау",
            waterSupply: "Сумен жабдықтау",
            cadastreNumber: "Кадастр нөмірі",
            cleaningSchedule: "Тазалау кестесі",
            note: "Ескертпе",
            district: "Әкімшілік аудан",
            reportError: "Қате туралы хабарлау"
        },
        lake: {
            title: "Көлдің паспорты",
            latitude: "Ендік",
            longitude: "Бойлық",
            name: "Көл атауы",
            district: "Әкімшілік аудан",
            reportError: "Қате туралы хабарлау"
        },
        pond: {
            title: "Тоғанның паспорты",
            latitude: "Ендік",
            longitude: "Бойлық",
            name: "Су нысанының атауы",
            purpose: "Мақсаты",
            exploitationYear: "Пайдалануға берілген",
            district: "Әкімшілік аудан",
            reportError: "Қате туралы хабарлау"
        },
        river: {
            title: "Өзеннің паспорты",
            name: "Өзен атауы",
            districts: "Әкімшілік аудандар",
            reportError: "Қате туралы хабарлау"
        },
        reservoir: {
            title: "Су қоймасының паспорты",
            latitude: "Ендік",
            longitude: "Бойлық",
            name: "Су нысанының атауы",
            exploitationYear: "Пайдалануға берілген",
            district: "Әкімшілік аудан",
            reportError: "Қате туралы хабарлау"
        },
        appeal: {
            back: "Артқа",
            title: "Өтінім жасау",
            lastName: "Тегі",
            firstName: "Аты",
            patronymic: "Әкесінің аты",
            email: "Email",
            phone: "Телефон нөмірі",
            phonePlaceholder: "8XXXXXXXXXX",
            bodyPlaceholder: "Өтінім мәтіні",
            addPhoto: "Фото қосу",
            send: "Жіберу"
        },
        filters: {
            title: "Сүзгілерді басқару",
            districts: "Аудандар",
            objects: "Нысандар",
            compensatory: "Компенсациялық отырғызу",
            redbook: "Қызыл кітапқа енгізілгендер",
            close: "Жабу"
        },
        tree: {
            title: "Нысанның паспорты",
            coordinates: "Координаттар",
            id: "Идентификациялық нөмір",
            breed: "Ағаш тұқымы",
            plantingType: "Жасыл желек түрі",
            category: "Жасыл желек санаты",
            age: "Жасы",
            height: "Биіктігі",
            diameter: "Диаметрі",
            condition: "Жағдайы",
            pests: "Зиянкестер",
            disease: "Ауру",
            event: "Шаруашылық іс-шара",
            status: "Мәртебесі",
            permitNumber: "Рұқсат нөмірі",
            plantingDate: "Отырғызу күні",
            addedDate: "Тізілімге енгізілген күні",
            district: "Аудан",
            reportError: "Қате туралы хабарлау",
            messages: "Хабарламалар",
            reply: "Жауап"
        },
        bush: {
            title: "Нысанның паспорты",
            coordinates: "Координаттар",
            id: "Идентификациялық нөмір",
            breed: "Бұта тұқымы",
            plantingType: "Жасыл желек түрі",
            plantingTypeValue: "Бұта",
            category: "Жасыл желек санаты",
            age: "Жасы",
            height: "Биіктігі",
            diameter: "Диаметрі",
            condition: "Жағдайы",
            pests: "Зиянкестер",
            disease: "Ауру",
            event: "Шаруашылық іс-шара",
            status: "Мәртебесі",
            permitNumber: "Рұқсат нөмірі",
            plantingDate: "Отырғызу күні",
            addedDate: "Тізілімге енгізілген күні",
            district: "Аудан",
            reportError: "Қате туралы хабарлау",
            messages: "Хабарламалар",
            reply: "Жауап"
        }
    }
};

export default new VueI18n({
    locale: "ru",
    fallbackLocale: "ru",
    messages
});